import type { AxiosInstance } from 'axios';
import axios from 'axios';

// Based on https://github.com/amio/embedded-google-fonts (license: MIT)

let client: AxiosInstance;

export function canLoadGoogleFont(): boolean {
	// if (typeof window.fetch === 'undefined') return false;
	if (typeof window.FileReader === 'undefined') return false;
	// if (typeof window.URL === 'undefined') return false;
	return true;
}

async function fetchCSS(url: string): Promise<string> {
	if (!client) {
		client = axios.create({ method: 'GET' });
	}
	return client.request({ url: url, method: 'get' }).then(function (res) {
		return res.data;
	});
}

async function embedFonts(cssText: string): Promise<string> {
	const fontLocations = cssText.match(/https:\/\/[^)]+/g);
	const fontLoadedPromises = fontLocations.map(function (location) {
		return new Promise(function (resolve, reject) {
			fetch(location).then(function (res) {
				return res.blob();
			}).then(function (blob) {
				const reader = new FileReader();
				reader.addEventListener('load', function (this: FileReader) {
					cssText = cssText.replace(location, this.result as string);
					resolve([location, this.result]);
				});
				reader.readAsDataURL(blob);
			}).catch(reject);
		});
	});
	return Promise.all(fontLoadedPromises).then(function () {
		return cssText;
	});
}

export async function getEmbeddableGoogleFont(name: string, display: 'swap' = null): Promise<string> {
	let url = `https://fonts.googleapis.com/icon?family=${escape(name.replace(/ /g, '+'))}`;
	if (display)
		url += '&display=' + escape(display);
	const cssText = await fetchCSS(url);
	const result = await embedFonts(cssText);
	return result;
}
